// Catch-effect particles. Tuning lives in docs/gameplay-config.md#particles.
//
// Each catch spawns 3-5 particles with random direction and PARTICLE_SPREAD_SPEED
// initial outward speed. Scale interpolates PARTICLE_SCALE_FROM → PARTICLE_SCALE_TO
// over the particle's lifetime; alpha fades linearly to 0.

import {
  PARTICLE_COUNT_MAX,
  PARTICLE_COUNT_MIN,
  PARTICLE_DURATION_S,
  PARTICLE_SPREAD_SPEED,
} from "../config/gameplay";

export type Particle = {
  x: number;
  y: number;
  vx: number;
  vy: number;
  bornAt: number;
  spriteKind: "ingredient" | "hazard";
};

export function spawnBurst(
  particles: Particle[],
  x: number,
  y: number,
  kind: "ingredient" | "hazard",
  now: number,
  rand: () => number = Math.random,
): void {
  const n = PARTICLE_COUNT_MIN + Math.floor(rand() * (PARTICLE_COUNT_MAX - PARTICLE_COUNT_MIN + 1));
  for (let i = 0; i < n; i++) {
    const angle = rand() * Math.PI * 2;
    particles.push({
      x,
      y,
      vx: Math.cos(angle) * PARTICLE_SPREAD_SPEED,
      vy: Math.sin(angle) * PARTICLE_SPREAD_SPEED,
      bornAt: now,
      spriteKind: kind,
    });
  }
}

export function pruneParticles(particles: Particle[], now: number): void {
  // In-place filter: shift surviving particles to the front, truncate.
  let w = 0;
  for (let r = 0; r < particles.length; r++) {
    if (now - particles[r]!.bornAt < PARTICLE_DURATION_S) {
      particles[w++] = particles[r]!;
    }
  }
  particles.length = w;
}
